import { CFImage } from '../../type/client-index'

export const IGProfile: CFImage = {
  url: 'https://imagedelivery.net/srkYgDd5YoRrGjuibYE5kw/38a19711-2f24-4865-1fb4-4c8eb33afb00/default',
  width: 2000,
  height: 1334
}

// STORIES

export const Story1: CFImage = {
  url: 'https://imagedelivery.net/srkYgDd5YoRrGjuibYE5kw/6dcc9d42-fdac-48f2-4665-9b33c41c6200/default',
  width: 1125,
  height: 2000
}
export const Story2: CFImage = {
  url: 'https://imagedelivery.net/srkYgDd5YoRrGjuibYE5kw/429473ea-d174-46d7-59a5-dcb5824f7300/default',
  width: 1125,
  height: 2000
}
export const Story3: CFImage = {
  url: 'https://imagedelivery.net/srkYgDd5YoRrGjuibYE5kw/e6a01df9-edf1-478a-1e8e-85fe5d7be300/default',
  width: 1500,
  height: 2666
}
export const Story4: CFImage = {
  url: 'https://imagedelivery.net/srkYgDd5YoRrGjuibYE5kw/5d4ab92a-7733-411a-0cc6-f65646e40600/default',
  width: 1125,
  height: 2000
}
export const Story5: CFImage = {
  url: 'https://imagedelivery.net/srkYgDd5YoRrGjuibYE5kw/7d07c3f3-7e06-4f3e-1473-1e2a08e92000/default',
  width: 1124,
  height: 2000
}

// BIG

export const Tag: CFImage = {
  url: 'https://imagedelivery.net/srkYgDd5YoRrGjuibYE5kw/709a7dfa-1b7c-4c05-62d0-f8317d1b5d00/1500',
  width: 1072,
  height: 1500
}

export const Poster: CFImage = {
  url: 'https://imagedelivery.net/srkYgDd5YoRrGjuibYE5kw/9d1b680d-9a80-4467-95c1-6994abc63d00/1750',
  width: 1750,
  height: 1312
}

// SHOOT

export const Shoot1: CFImage = {
  url: 'https://imagedelivery.net/srkYgDd5YoRrGjuibYE5kw/cefaabdf-d29e-45e8-aaa2-36525765aa00/default',
  width: 1000,
  height: 1500
}
export const Shoot2: CFImage = {
  url: 'https://imagedelivery.net/srkYgDd5YoRrGjuibYE5kw/62c72aac-de43-4a31-36e7-027ee0b5fe00/default',
  width: 1000,
  height: 1500
}
export const Shoot3: CFImage = {
  url: 'https://imagedelivery.net/srkYgDd5YoRrGjuibYE5kw/541af313-0439-4f17-86ac-78cbb23dfd00/default',
  width: 1000,
  height: 1500
}
export const Shoot4: CFImage = {
  url: 'https://imagedelivery.net/srkYgDd5YoRrGjuibYE5kw/61345976-c752-4640-aae0-666dd1f23700/default',
  width: 1000,
  height: 1500
}
export const Shoot5: CFImage = {
  url: 'https://imagedelivery.net/srkYgDd5YoRrGjuibYE5kw/9d2bb218-20a5-4067-76d5-1f361b1d5700/default',
  width: 1000,
  height: 1500
}
export const Shoot6: CFImage = {
  url: 'https://imagedelivery.net/srkYgDd5YoRrGjuibYE5kw/8960e519-cf90-444a-147f-a53d7adb5e00/default',
  width: 1000,
  height: 1500
}
